import { useState, useEffect } from "react";
import { breakpoints } from "../constant.js";
/**
 * Returns boolean if the screen width is at the specified breakpoint or larger.
 */ const useScreenMediaQuery = (query)=>{
    const [matches, setMatches] = useState(false);
    useEffect(()=>{
        const media = window.matchMedia(`(min-width: ${breakpoints[query]})`);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = ()=>setMatches(media.matches);
        window.addEventListener('resize', listener);
        return ()=>window.removeEventListener('resize', listener);
    }, [
        matches,
        query
    ]);
    return matches;
};
export default useScreenMediaQuery;
